import { hasPermission } from "../auth.js";

export const unresolvedName = "Unbekannt";

export function isResolvedName(name) {
    return name != null && name !== unresolvedName;
}

export function deepLink(permission, hash, valid = true) {
    if (!valid || !hasPermission(permission)) return undefined;
    return () => { window.location.hash = hash; };
}